// @ts-ignore untyped loader
import _quickFetch, {
  type QuickFetch,
} from 'exports-loader?exports=default%20quickFetch!./internal/index';

// @ts-ignore untyped loader
import * as currentPackage from 'current-package-loader!';

const quickFetch = _quickFetch as QuickFetch;

// quick-fetch relies on these variables being set
quickFetch._currentProject = currentPackage.name;
quickFetch._currentProjectVersion = currentPackage.version;

export default quickFetch;
